(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/transcript-file/assets/javascripts/transcript-file.js') >= 0) return;  svs.modules.push('/components/accountservices/transcript-file/assets/javascripts/transcript-file.js');

'use strict';

const logger = svs.core.log.getLogger('components:transcript-file');
function order(orderType, successCallback, errorCallback) {
  svs.core.jupiter.call({
    path: '/compliance/1/ordercustomertranscript',
    method: 'POST',
    data: {
      transcriptType: orderType
    }
  }, data => {
    logger.info("Customer ordered transcript file of type ".concat(orderType));
    successCallback({
      orderStatus: 'NOTREADY',
      orderType
    }, data);
  }, error => {
    const errorCode = error.responseJSON.error.code;
    let errorMessage;
    logger.info("Error ordering transcript file of type ".concat(orderType), svs.core.jupiter.parseErrorResponse(error));
    if (errorCode === 30010) {
      errorMessage = 'Du har inte rätt behörighet för att beställa detta utdrag. För vissa typer krävs att du har loggat in med BankID.';
    } else if (errorCode === 30020) {
      errorMessage = 'Felaktigt värde inskickat för beställning. Beställd typ av utdrag finns ej.';
    } else if (errorCode === 30040) {
      errorMessage = 'Det finns redan ett beställt utdrag av denna typ som bearbetas eller är färdigt för nedladdning.';
    } else {
      errorMessage = 'Ett fel har inträffat vid beställning av utdrag. Försök igen lite senare och om felet kvarstår, kontakta Kundservice';
    }
    errorCallback(errorCode, errorMessage, error);
  });
}
svs.accountservices.transcript_file.order = order;
if (typeof exports === 'object') {
  module.exports = {
    order: svs.accountservices.transcript_file.order
  };
}

 })(window);